import { TaskStatus as TaskStatusEnum } from "@common/types/task";
import { Tooltip } from "@design-system/Tooltip/Tooltip";
import styles from "./TaskStatusIcon.module.scss";
import { TASK_STATUS_CONFIG } from "./taskStatus.constants";

interface TaskStatusIconProps {
    status: TaskStatusEnum;
    withTooltip?: boolean;
}

export const TaskStatusIcon = ({
    status,
    withTooltip = true,
}: TaskStatusIconProps) => {
    const config = TASK_STATUS_CONFIG[status];
    const { Icon, tooltip } = config;

    const icon = <Icon className={styles.taskStatusIcon} />;

    if (withTooltip) {
        return (
            <Tooltip content={tooltip}>
                <span className={styles.iconWrapper}>{icon}</span>
            </Tooltip>
        );
    }

    return icon;
};
